import React from 'react';

import { Header } from '@/components/global/Header';
import { Title } from '@/components/global/Title';
import { Description } from '@/components/global/Description';
import { Score } from '@/components/Template/Template4/Score';
import { ExpiredIn } from '@/components/Template/Template4/ExpiredIn';
import { Notes } from '@/components/Template/Template4/Notes';
import { Slider } from '@/components/Template/Template4/Slider';
import { Rules } from '@/components/Template/Template4/Rules';

import { TRecommendation } from '@/services/requests/Recommendation/types/template4';

type TProps = {
  data: TRecommendation;
};

export function Layout2({ data }: TProps) {
  return (
    <>
      <Header data={data.header} template="4" />
      <Title
        data={{
          title: data.rec_title.title,
        }}
        template="4"
      />
      <Description data={data} template="4" />
      <Score data={data} />
      <Rules data={data} />
      <ExpiredIn data={data} />
      <Notes data={data} />
      <Slider data={data} tabName="" tabActive />
    </>
  );
}
